<template>
  <div class="investigator-detail" v-loading="loading">
    <div class="top-btn">
      <DialogConditionBtn :filter.sync="filter" :btnText="'高级筛选'" :btnPlain="true" @save="onSaveFilter"></DialogConditionBtn>
      <div>
        <el-button type="primary" @click="addInvestigator">添加调查员</el-button>
        <span class="ml-3" v-if="false"><el-button type="primary" plain>同步调查员</el-button></span>
        <span class="ml-3"><el-button type="text" @click="shareInvestigator">邀请链接</el-button></span>
      </div>
    </div>
      <div class="statistics">
        总计调查员 <span>{{ page.total }}</span> 人，黑名单 <span>{{ blackNum }}</span> 人
      </div>
      <DataTable
        ref="dataTable"
        selection
        :height="tableHeight"
        :loading="tableLoading"
        :data="tableData"
        :columns="tableColumns"
        :page="page"
        :showPage="true"
        :showTooltip="false"
        :tableHeaderStyle="tableHeaderColor"
        :disabledAllCheck="disabledAllCheck"
        @selection-change="handleSelectionChange"
        @size-change="handleSizeChange"
        @pagination-current-change="handleCurrentChange"
      >
        <!-- 明察暗访数据-审核案件通过率 -->
        <template #case_pass_ratio="{ row }"> {{ Math.round(row.case_pass_ratio) }}% </template>
        <!-- 问卷调查数据-答卷审核通过率 -->
        <template #answer_pass_ratio="{ row }"> {{ Math.round(row.answer_pass_ratio) }}% </template>
        <!-- 费用结算数据-费用结算金额 -->
        <template #settle_amount="{ row }">
          {{ (Math.round(row.settle_amount * 100) / 100).toFixed(2) }}
        </template>
        <!-- 上传文件的展示 -->
        <template v-for="item in fillList" :slot="item" slot-scope="scope">
          <div :key="item">
            <div v-if="showImg(scope.row[item]) === '--'">--</div>
            <el-image v-else-if="showImg(scope.row[item])" style="width: 120px" :src="baseURL + scope.row[item]" :preview-src-list="bigImgUrl" @click="showBigImg(scope.row[item])" />
            <el-button v-else type="text" @click="openFill(scope.row[item])">{{decodeURIComponent(scope.row[item]) | fillName}}</el-button>
          </div>
        </template>
        <!-- 黑名单 -->
        <template #status="{ row }">
          <div class="w-8 h-6 ml-12 pl-1" v-if="row.state" @click="setBlack(!row.state, row)">
            <el-switch v-model="row.state" disabled />
          </div>

          <el-popover v-else popper-class="tablePop" placement="top" width="270" :ref="row.investigatorName" class="ml-3">
            <div class="pb-4 leading-22 text-theme-black-850">
              <div class="py-2 pl-3">
                <i class="el-icon-warning text-yellow-theme text-medium-x mr-2"></i>
                <span class="text-large">加入黑名单</span>
              </div>
              <div class="pl-9 pr-3">
                <span>加入黑名单后，无法继续配任务、回收问卷，确定加入黑名单吗</span>
              </div>
            </div>
            <div class="text-right mr-3">
              <el-button size="mini" @click="closeTablePopover()">取消</el-button>
              <el-button type="primary" size="mini" @click="setBlack(!row.state, row)">加入</el-button>
            </div>
            <el-switch v-model="row.state" disabled slot="reference" />
          </el-popover>
        </template>
        <!-- 操作 -->
        <template #operation="{ row }">
          <el-button type="text" @click="checkDetail(row)">查看</el-button>
          <el-button type="text" @click="editInfo(row)" :disabled="!isAdmin">编辑</el-button>
          <el-popover popper-class="tablePop" placement="top" width="270" :ref="row.investigatorName" class="ml-3">
            <div v-if="isAdmin && (row.allotTasks || row.recycleData)">
              <div class="pb-4 leading-22 text-theme-black-850">
                <div class="py-2 pl-3">
                  <i class="el-icon-warning text-yellow-theme text-medium-x mr-2"></i>
                  <span class="text-large">删除</span>
                </div>
                <div class="pl-9 pr-3">
                  <span>调查员已分配任务或回收数据均无法删除调查员</span>
                </div>
              </div>
              <div class="text-right mr-3">
                <el-button type="primary" size="mini" @click="closeTablePopover()">我知道了</el-button>
              </div>
            </div>
            <div v-else-if="isAdmin">
              <div class="pb-4 leading-22 text-theme-black-850">
                <div class="py-2 pl-3">
                  <i class="el-icon-warning text-yellow-theme text-medium-x mr-2"></i>
                  <span class="text-large">删除</span>
                </div>
                <div class="pl-9 pr-3">
                  <span class="text-red">调查员删除后不可恢复</span>
                  <span>，还要继续吗？删除后，您可重新添加调查员</span>
                </div>
              </div>
              <div class="text-right mr-3">
                <el-button size="mini" @click="closeTablePopover()">取消</el-button>
                <el-button type="danger" size="mini" @click="delItemData(row)">删除</el-button>
              </div>
            </div>
            <div v-else-if="!isAdmin">
              <div class="pb-4 leading-22 text-theme-black-850">
                <div class="py-2 pl-3">
                  <i class="el-icon-warning text-yellow-theme text-medium-x mr-2"></i>
                  <span class="text-large">删除</span>
                </div>
                <div class="pl-9 pr-3">
                  <span>您无删除调查员权限，确定删除请联系管理员！</span>
                </div>
              </div>
              <div class="text-right mr-3">
                <el-button type="primary" size="mini" @click="closeTablePopover()">我知道了</el-button>
              </div>
            </div>
            <el-button type="text" slot="reference">删除</el-button>
          </el-popover>
        </template>
        <!-- 底部按钮 -->
        <template #page-left>
          <div class="footer-btn">
            <el-checkbox
              v-model="currentCheck"
              :disabled="tableData.length === 0 || isAll"
              @change="handleCurrentcheck"
              class="mr-1"
            ></el-checkbox>
            <p class="mr-2" style="font-size: 14px; color: rgba(0, 0, 0, 0.65)">
              已选择{{ isAll ? page.total : selectList.length }}项
            </p>
            <el-checkbox v-model="isAll" class="mr-2" @change="handleSelectAll" :disabled="page.total === 0"
              >选择全部</el-checkbox
            >
            <el-button type="primary" @click="exportInvestigator" class="mx-3">导出</el-button>
            <el-popover placement="top" width="270" v-model="popoverFlag">
              <div v-if="isAdmin">
                <div class="pb-4 leading-22 text-theme-black-850">
                  <div class="py-2 pl-3">
                    <i class="el-icon-warning text-yellow-theme text-medium-x mr-2"></i>
                    <span class="text-large">删除</span>
                  </div>
                  <div class="pl-9 pr-3">
                    <span class="text-red">调查员删除后不可恢复</span>
                    <span>，还要继续吗？删除后，您可重新添加调查员</span>
                  </div>
                </div>
                <div class="text-right mr-3">
                  <el-button size="mini" @click="closeTablePopover()">取消</el-button>
                  <el-button type="danger" size="mini" @click="delTableData">删除</el-button>
                </div>
              </div>
              <div v-else>
                <div class="pb-4 leading-22 text-theme-black-850">
                  <div class="py-2 pl-3">
                    <i class="el-icon-warning text-yellow-theme text-medium-x mr-2"></i>
                    <span class="text-large">删除</span>
                  </div>
                  <div class="pl-9 pr-3">
                    <span>您无删除调查员权限，确定删除请联系管理员！</span>
                  </div>
                </div>
                <div class="text-right mr-3">
                  <el-button type="primary" size="mini" @click="closeTablePopover()">我知道了</el-button>
                </div>
              </div>
              <el-button type="danger" plain slot="reference">删除</el-button>
            </el-popover>
          </div>
        </template>
      </DataTable>
    <el-drawer
      :title="drawerTitle"
      size="65%"
      :visible.sync="drawerFlag"
      direction="rtl"
      :before-close="handleDrawerClose"
      :destroy-on-close="true"
    >
      <!-- 调查员详情的抽屉 -->
      <InvestigatorDetailDrawer v-if="detailDrawerFlag" :isAdmin="isAdmin" :phone="editPhone" :item="investigatorItem" />
      <!-- 编辑调查员的抽屉 -->
      <InvestigatorEditDrawer
        v-if="editDrawerFlag"
        :isAdmin="isAdmin"
        :phone="editPhone"
        :item="investigatorItem"
        @close-drawer="handleDrawerClose"
      />
      <!-- 添加调查员的抽屉 -->
      <InvestigatorAddDrawer
        v-if="addDrawerFlag"
        :isAdmin="isAdmin"
        :tableLength="page.total"
        @close-drawer="handleDrawerClose"
      />
      <!-- 邀请连接的抽屉 -->
      <InvestigatorShareDrawer v-if="shareDrawerFlag" :isAdmin="isAdmin" />
    </el-drawer>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import DataTable from '@/components/base/DataTable'
import { getFreeLink } from '@/api/wenjuan/publish'
import DialogConditionBtn from './DialogConditionBtn'
import { notSupplement, zeroSupplement } from './config'
import InvestigatorAddDrawer from './InvestigatorAddDrawer'
import InvestigatorEditDrawer from './InvestigatorEditDrawer'
import InvestigatorShareDrawer from './InvestigatorShareDrawer'
import InvestigatorDetailDrawer from './InvestigatorDetailDrawer'
import {
  getOrInitInvestigatorSurvey,
  getTableHeader,
  getTable,
  deleteByIds,
  updateStatusById,
  exportExcel
} from '@/api/more-app/investigator-base'

export default {
  name: 'InvestigatorDetail',
  components: {
    DialogConditionBtn,
    DataTable,
    InvestigatorDetailDrawer,
    InvestigatorEditDrawer,
    InvestigatorAddDrawer,
    InvestigatorShareDrawer
  },
  data() {
    return {
      baseURL: window.location.origin + '/fill/api/v1/download?fileName=',
      fillList: [],
      imgType: ['.png', '.jpeg', '.jpg', '.bmp', '.gif'],
      bigImgUrl: [''],
      loading: true,
      oldOptions: [],
      surveyId: '',
      filter: {
        conditionRule: 2,
        ruleGroups: [],
        rules: []
      },
      showDialog: false,
      blackNum: 0, // 黑名单数量
      tableLoading: false,
      tableHeight: 'calc(100vh)',
      tableData: [],
      tableColumns: [],
      currentCheck: false,
      isAll: false,
      page: {
        pageSizes: [10, 20, 30, 40, 50, 100],
        currentPage: 1,
        pageSize: 20,
        total: 0,
        isSmall: true
      },
      selectList: [],
      popoverFlag: false, // 删除提示的显隐
      disabledAllCheck: false,
      drawerFlag: false,
      detailDrawerFlag: false,
      editDrawerFlag: false,
      addDrawerFlag: false,
      shareDrawerFlag: false,
      notShowCollectAgentDialog: false,
      editPhone: '',
      drawerTitle: '调查员详情',
      investigatorItem: {}
    }
  },
  filters: {
    fillName(val) {
      return val.split('_')[1]
    }
  },
  watch: {
    selectList(val) {
      if (val.length) {
        this.currentCheck = true
      } else {
        this.currentCheck = false
      }
    },
    // addDrawerFlag(val) {
    //   if (!val) {
    //     this.getHeader()
    //   }
    // }
  },
  computed: {
    isAdmin() {
      if (GlobalConfig.getCompanyId() == 0 || this.$store.getters.userInfo?.isAdmin == 1) {
        return true
      } else if (this.$store.getters.userInfo?.isAdmin != 1) {
        return false
      }
    },
    isPersonal() {
      if (GlobalConfig.getCompanyId() == 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // 设置大图路径
    showBigImg(val) {
      this.bigImgUrl = [`${this.baseURL + val}`]
    },
    // 打开表格中的文件
    openFill(val) {
      window.open(this.baseURL + val)
    },
    // 表格中的图片是否展示
    showImg(val) {
      if(val === '--') return val
      return this.imgType.some(item => val.includes(item))
    },
    // 调查员删除(单个)
    delItemData(row) {
      let data = JSON.parse(JSON.stringify(this.filter))
      data.investigatorIds = [row.id]
      deleteByIds(data)
        .then(res => {
          if (res.data.code !== 0) return
          this.$message.success('调查员删除成功')
          document.body.click()
          this.page.currentPage = 1
          this.getData()
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 调查员批量删除
    delTableData() {
      if (this.selectList.length === 0 && !this.isAll) {
        this.$message.error('请勾选数据')
        return
      }
      let data = JSON.parse(JSON.stringify(this.filter))
      if (this.isAll) {
        data.investigatorIds = []
      } else {
        data.investigatorIds = this.selectList.map(item => {
          return item.id
        })
      }
      deleteByIds(data)
        .then(res => {
          if (res.data.code !== 0) return
          this.$message.success(`已选择${res.data.data.total}名调查员，成功删除${res.data.data.success}名`)
          document.body.click()
          // 若删除全部，清空筛选条件再查询
          if (this.isAll) {
            this.filter = {
              conditionRule: 2,
              ruleGroups: [],
              rules: []
            }
            this.isAll = false
          }
          // 清空勾选
          this.isAll = false
          this.handleSelectAll()
          this.page.currentPage = 1
          this.getData()
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 高级筛选
    onSaveFilter(filter) {
      if(filter){
        this.page.currentPage = 1;
        this.filter = filter;
      }
      this.getData()
    },
    // 关闭表格的删除弹窗
    closeTablePopover() {
      document.body.click()
    },
    //设置表头的颜色
    tableHeaderColor({ rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 4) {
        return 'background: rgba(0,190,106,0.10);color: rgba(0,0,0,0.85);'
      } else if (rowIndex === 0 && columnIndex === 5) {
        return 'background: rgba(232,163,27,0.10);color: rgba(0,0,0,0.85);'
      } else if (rowIndex === 0 && columnIndex === 6) {
        return 'background: rgba(227,65,82,0.10);color: rgba(0,0,0,0.85);'
      } else if (rowIndex === 0) {
        return 'background: #f5f5f5;color: rgba(0,0,0,0.85);'
      } else if (rowIndex === 1 && columnIndex >= 0 && columnIndex <= 3) {
        return 'background: rgba(0,190,106,0.10);color: rgba(0,0,0,0.85);'
      } else if (rowIndex === 1 && columnIndex >= 4 && columnIndex <= 7) {
        return 'background: rgba(232,163,27,0.10);color: rgba(0,0,0,0.85);'
      } else if (rowIndex === 1 && (columnIndex === 8 || columnIndex === 9)) {
        return 'background: rgba(227,65,82,0.10);color: rgba(0,0,0,0.85);'
      } else {
        return 'color:rgba(0,0,0,0.85);background: #ffffff;'
      }
    },
    // 底部勾选当前页
    handleCurrentcheck(val) {
      if (this.selectList.length < 1) {
        this.$refs.dataTable.toggleAllSelection()
        this.selectList = this.tableData
      } else {
        this.$refs.dataTable.clearSelection()
        this.selectList = []
      }
    },
    // 底部勾选全部数据
    handleSelectAll() {
      if (this.isAll) {
        this.$refs.dataTable.toggleAllSelection()
        this.disabledAllCheck = true
        this.currentCheck = true
      } else {
        this.$refs.dataTable.clearSelection()
        this.disabledAllCheck = false
        this.currentCheck = false
        this.selectList = []
      }
    },
    handleSelectionChange(list) {
      if (this.isAll) {
        this.currentCheck = true
      } else if (list.length > 0) {
        this.currentCheck = true
        this.selectList = list
      } else {
        this.currentCheck = false
        this.selectList = []
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.getData()
    },
    // 加入黑名单
    setBlack(val, row) {
      let params = {
        investigatorId: row.id,
        status: Number(val)
      }
      updateStatusById(params)
        .then(res => {
          if (res.data.code !== 0) return
          row.state = val
          row.status = Number(val)
          document.body.click()
          if (!val) {
            this.blackNum--
            this.$message.success('关闭黑名单成功')
          } else {
            this.blackNum++
            this.$message.success('已成功加入黑名单，若想继续配任务或回收问卷，可关闭黑名单')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 导出
    exportInvestigator() {
      if (this.selectList.length === 0 && !this.isAll) {
        this.$message.error('请勾选数据')
        return
      }
      this.exportMessage()
      let data = {
        phones: [],
        query: this.filter,
        selectAll: this.isAll
      }
      if (this.isAll) {
        data.query.investigatorIds = []
      } else {
        data.query.investigatorIds = this.selectList.map(item => {
          return item.id
        })
        data.phones = this.selectList.map(item => {
          return item.investigator_phone
        })
      }
      exportExcel(data)
        .then(res => {
          let blob = new Blob([res.data], { type: 'text/xls' })
          let csvUrl = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = csvUrl
          link.download = '调查员详情' + '.xlsx'
          link.click()
          // document.body.removeChild(link)
          URL.revokeObjectURL(csvUrl)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 导出提示语
    exportMessage() {
      const h = this.$createElement
      this.$message({
        message: h('p', null, [
          h('p', null, '导出文件生成中'),
          h('p', null, '正在生成调查员文件，文件生成后浏览器将自动下载，请注意查收'),
          h(
            'button',
            {
              on: {
                click: this.messageClose
              }
            },
            '我知道了'
          )
        ]),
        position: 'bottom-left',
        customClass: 'el-message-box_style',
        type: 'success',
        showClose: true,
        offset: 250,
        duration: 0
      })
    },
    messageClose() {
      this.$message.closeAll()
    },
    // 关闭抽屉
    async handleDrawerClose() {
      this.detailDrawerFlag = false
      this.editDrawerFlag = false
      this.addDrawerFlag = false
      this.shareDrawerFlag = false
      this.drawerFlag = false
      await this.getHeader()
      await this.getData()
    },
    // 查看详情的抽屉
    checkDetail(row) {
      this.investigatorItem = row
      this.editPhone = row.investigator_phone
      this.drawerTitle = '调查员详情'
      this.detailDrawerFlag = true
      this.drawerFlag = true
    },
    // 编辑信息的抽屉
    editInfo(row) {
      if (this.notShowCollectAgentDialog) {
        this.$message.error('请先配置调查员信息')
        return
      }
      this.investigatorItem = row
      this.editPhone = row.investigator_phone
      this.drawerTitle = '编辑调查员'
      this.editDrawerFlag = true
      this.drawerFlag = true
    },
    // 添加调查员的抽屉
    addInvestigator() {
      if (this.notShowCollectAgentDialog) {
        this.$message.error('请先配置调查员信息')
        return
      }
      this.drawerTitle = '添加调查员'
      this.addDrawerFlag = true
      this.drawerFlag = true
    },
    // 邀请连接的抽屉
    shareInvestigator() {
      if (this.notShowCollectAgentDialog) {
        this.$message.error('请先配置调查员信息')
        return
      }
      this.drawerTitle = '调查员信息收集表'
      this.shareDrawerFlag = true
      this.drawerFlag = true
    },
    // 获取问卷id
    getSurveyId() {
      getOrInitInvestigatorSurvey()
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.surveyId = res.data.data.id
          GlobalConfig.setSurveyId(res.data.data.id)
          GlobalConfig.setSurveyTitle(res.data.data.title)
          this.getSurveyState() // 获取调查员答卷信息,用于发出提示消息
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取调查员问卷状态
    async getSurveyState() {
      const params = {
        channelType: '0',
        surveyId: GlobalConfig.getSurveyId()
      }
      await getFreeLink(params)
        .then(res => {
          if (res.data.data.length <= 0) {
            this.notShowCollectAgentDialog = true
          } else {
            this.notShowCollectAgentDialog = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getHeader() {
      await getTableHeader()
        .then(res => {
          if (res.data.code !== 0) return
          this.oldOptions = res.data.data
          let openlySecretly = {
            label: '明察暗访数据',
            value: 'openly_secretly',
            children: []
          }
          let questionInvestigation = {
            label: '问卷调查数据',
            value: 'question_investigation',
            children: []
          }
          let expenseSettlement = {
            label: '费用结算数据',
            value: 'expense_settlement',
            children: []
          }
          this.tableColumns = []
          this.fillList = []
          this.oldOptions.forEach(item => {
            if(item.questionType === 18) this.fillList.push(item.id)
            let unit = {
              label: item.name,
              value: item.id,
              width: 160,
              tooltip: item.questionType === 18
            }
            if (item.index < 3 || item.index > 12) {
              if (item.index < 3) {
                // 前三个左固定，且减小宽度
                unit.fixed = 'left',
                unit.width = 120
              }
              if (item.id === 'score' || item.id === 'creator_time') {
                unit.sortable = true
                if (item.id === 'score') unit.width = 80
              }
              if (this.isPersonal && item.id === 'creator_name') return
              // if(item.id === 'allotTasks' || item.id === 'recycleData' || item.id === 'id') return
              this.tableColumns.push(unit)
            } else {
              if (item.index >= 3 && item.index <= 6) {
                unit.sortable = true
                openlySecretly.children.push(unit)
                if (item.index === 6) this.tableColumns.push(openlySecretly)
              } else if (item.index >= 7 && item.index <= 10) {
                unit.sortable = true
                questionInvestigation.children.push(unit)
                if (item.index === 10) this.tableColumns.push(questionInvestigation)
              } else if (item.index === 11 || item.index === 12) {
                unit.sortable = true
                expenseSettlement.children.push(unit)
                if (item.index === 12) this.tableColumns.push(expenseSettlement)
              }
            }
          })
          this.tableColumns.push({
            label: '操作',
            value: 'operation',
            fixed: 'right',
            width: 150
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getData() {
      this.loading = true
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize
      }
      this.blackNum = 0
      await getTable(this.filter, params)
        .then(res => {
          if (res.data.code !== 0) return
          this.page.total = res.data.data.total
          let tableData = res.data.data.records
          let list = []
          tableData.forEach(item => {
            let obj = {}
            this.oldOptions.forEach((v, index) => {
              obj[v.id] = item[index]
            })
            obj.state = Boolean(obj.status)
            if (obj.status === 1) this.blackNum++
            list.push(obj)
          })
          // 添加占位符
          list.forEach(item => {
            for (let key in item) {
              if (notSupplement.includes(key)) {
                continue
              } else if (zeroSupplement.includes(key)) {
                item[key] = item[key] || 0
              } else {
                item[key] = item[key] || '--'
              }
            }
          })
          this.tableData = list
          // 处理表头
          this.tableColumns.forEach((item, index) => {
            if (item.value === 'allotTasks') {
              this.tableColumns.splice(index, 3)
            }
          })
          this.$nextTick(() => {
            // 单元格偏移的问题
            this.tableHeight = 'calc(100vh - 300px)'
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  async mounted() {
    await this.getHeader()
    await this.getData()
    await this.getSurveyId()
  },
  beforeDestroy() {
    GlobalConfig.setSurveyId(null)
  }
}
</script>

<style lang="scss" scoped>
.investigator-detail {
  .top-btn {
    @apply flex justify-between;
  }
  .statistics {
    @apply text-medium text-theme-black-850 leading-22 font-normal pt-4 pb-3 text-right;
    font-family: PingFangSC-Regular;
    span {
      @apply font-semibold;
    }
  }
  .footer-btn {
    @apply flex items-center;
    .el-checkbox {
      @apply ml-5 mr-1;
    }
  }
}
::v-deep .el-switch.is-disabled {
  opacity: 1;
}
::v-deep .el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: pointer !important;
}
</style>
<style lang="scss">
.el-message-box_style {
  @apply items-start;
  .el-message__icon {
    @apply text-medium-x mt-0.5 mr-4;
  }
  .el-message__closeBtn {
    top: 20%;
  }
  & > p {
    p:nth-child(1) {
      @apply text-medium-x text-theme-black-850 pb-3;
    }
    p:nth-child(2) {
      @apply text-medium text-theme-black-650 pb-3;
    }
    button {
      @apply bg-transparent text-theme cursor-pointer;
    }
  }
}
</style>
